import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const HEADER_MOBILE_HEIGHT = "48px";

export const MHeaderStyle = {
  self: css`
    position: fixed;
    top: 0;
    width: 100%;
    height: ${HEADER_MOBILE_HEIGHT};
    padding: 0 12px 0 20px;
    background-color: ${theme.colors.orange[200]};
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 2;
  `,

  barIcon: css`
    font-size: 26px;
    path {
      fill: white;
    }
  `,

  logo: css`
    max-width: 150px;
    min-width: 100px;

    max-height: 48px;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  `,

  appMobileIcon: css`
    width: 23px;
    margin-top: 3px;

    path:first-child {
      fill: white;
    }
  `,
};
